var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3318_8346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.922 47.7841C68.9593 51.8573 75.25 60.944 75.25 71.5H68.75C68.75 63.583 64.032 56.768 57.2541 53.713L59.922 47.7841ZM57.6877 11.0929C64.1818 13.7703 68.75 20.1617 68.75 27.625C68.75 36.9531 61.6136 44.6069 52.5 45.4272V38.8849C58.0143 38.0971 62.25 33.358 62.25 27.625C62.25 23.1379 59.6552 19.2596 55.8833 17.4081L57.6877 11.0929Z",
    fill: "url(#paint0_linear_3318_8346)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 71.5C6.5 57.1405 18.1406 45.5 32.5 45.5C46.8595 45.5 58.5 57.1405 58.5 71.5H52C52 60.7305 43.2695 52 32.5 52C21.7304 52 13 60.7305 13 71.5H6.5ZM32.5 42.25C21.7262 42.25 13 33.5238 13 22.75C13 11.9762 21.7262 3.25 32.5 3.25C43.2738 3.25 52 11.9762 52 22.75C52 33.5238 43.2738 42.25 32.5 42.25ZM32.5 35.75C39.6825 35.75 45.5 29.9325 45.5 22.75C45.5 15.5675 39.6825 9.75 32.5 9.75C25.3175 9.75 19.5 15.5675 19.5 22.75C19.5 29.9325 25.3175 35.75 32.5 35.75Z",
    fill: "url(#paint1_linear_3318_8346)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3318_8346",
    x1: 77,
    y1: 37.375,
    x2: 145.25,
    y2: 37.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3318_8346",
    x1: 6.5,
    y1: 37.375,
    x2: 68.25,
    y2: 37.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3318_8346"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 78,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.9741a39d66d55e40715d475aa6654b50.svg";
export { ForwardRef as ReactComponent };